function loadCustomVideo() {
    var customProductVideo = document.querySelector('.js-custom-product-video');

    if (!checkResolution('cxs') && customProductVideo) {
        customProductVideo.setAttribute('src', customProductVideo.dataset.src);
        customProductVideo.play();
    }
}

function addKarsaProduct() {
    var $productDetail = $('.js-product-detail');

    if ($productDetail.length) {
        var model = $productDetail.data('model'),
            price = $productDetail.data('price'),
            hash = $productDetail.find('.product__info').data('karsa-karsa-hash'),
            shopId = $productDetail.find('.product__info').data('karsa-shop-id');

        if (!shopId) {
            return;
        }

        karsaMonitorCollector.addProduct(model, price);

        if (hash) {
            karsaMonitorCollector.send(shopId, hash);
        } else {
            karsaMonitorCollector.send(shopId);
        }
    }
}

var offset_pos = new Array(),
    $click_nav = 0;

function createStars($elem, options) {
    $elem.starRating($.extend({}, {
        starSize: 16,
        initialRating: $elem.attr('data-stars') * 5 / 100,
        readOnly: false,
        starShape: 'rounded',
        emptyColor: '#E0EBF5',
        activeColor: '#F8C81C',
        hoverColor: '#F8C81C',
        ratedColor: '#F8C81C',
        useGradient: false,
        disableAfterRate: false
    }, options));
}

function checkDescriptionHeight() {
    var $wrapper = $('.product__content__main__box__text'),
        $inner = $('.product__content__main__box__text__inner'),
        $checker = $('.product__content__main__box__text__checker'),
        $more = $('.product__content__main__box__text__more'),
        maxHeight = parseInt( $inner.css('max-height') ),
        isSmaller = $checker.height() <= maxHeight;

    if (!$wrapper.hasClass('show')) {
        $wrapper.toggleClass('is-smaller', isSmaller);
        $more.toggleClass('h-nodisplay', isSmaller);
    }
    else {
        $wrapper.removeClass('is-smaller');
        $more.removeClass('h-nodisplay');
    }
}

$(document).ready(function() {
    checkDescriptionHeight();
    loadCustomVideo();
    addKarsaProduct();

    /* Beg - Product tabs btn in mobile */
    $('.btn-group-tabs .dropdown-menu li a').on('click', function(event) {
        $(this)
            .parents('.dropdown-menu')
            .find('li')
            .removeClass('active');
        $(this)
            .parents('.dropdown-menu')
            .find('a')
            .removeClass('active');
        $(this).addClass('active');

        $(this)
            .parents('.bootstrap-select')
            .find('.filter-option')
            .text($(this).text());
    });
    /* End - Product tabs btn in mobile */

    $('.jsShowMoreDescription').on('click', function() {
        if ($(this).hasClass('active')) {
            $(this)
                .removeClass('active')
                .children('span')
                .text($(this).attr('data-more'));
            $('.product__content__main__box__text').removeClass('show');
        } else {
            $(this)
                .addClass('active')
                .children('span')
                .text($(this).attr('data-less'));
            $('.product__content__main__box__text').addClass('show');
        }

        generate_offset();

        checkDescriptionHeight();

        return false;
    });

    $('.jsShowMoreReviews').on('click', function() {
        if ($(this).hasClass('active')) {
            $(this)
                .removeClass('active')
                .children('span')
                .text($(this).attr('data-more'));
            $('.product__content__reviews__listing').removeClass('show');
        } else {
            $(this)
                .addClass('active')
                .children('span')
                .text($(this).attr('data-less'));
            $('.product__content__reviews__listing').addClass('show');
        }

        generate_offset();

        return false;
    });

    /* Beg - Product - gallery */
    $('.product__gallery__item--count').on('click', function(event) {
        event.preventDefault();

        $('.product__gallery__item--hide:first').click();
    });
    $('.product__gallery__item--others').on('click', function(event) {
        event.preventDefault();

        $('.product__gallery__item:first')
            .next()
            .click();
    });

    $('.product__large.link').on('click', function(event) {
        event.preventDefault();

        $('.product__gallery__item:first').click();
    });
    /* End - Product - gallery */

    /* Beg - Slider reviews */
    $('.slider-reviews').each(function() {
        $(this).slick({
            dots: true,
            arrows: false,
            infinite: false,
            adaptiveHeight: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
        });
    });
    /* End - Slider reviews */

    /* Beg - Slider mobile gallery */
    $('.slider-product-detail-gallery').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
    });
    /* End - Slider mobile gallery */

    /* Beg - Slider products */
    $('.slider-products').each(function() {
        $(this)
            .slick({
                dots: false,
                arrows: true,
                infinite: true,
                adaptiveHeight: false,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 4,
                prevArrow: $(this)
                    .parents('.slider__products__box')
                    .find('.slider__products__prev'),
                nextArrow: $(this)
                    .parents('.slider__products__box')
                    .find('.slider__products__next'),
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            infinite: false,
                            slidesToShow: 2.2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 550,
                        settings: {
                            infinite: false,
                            slidesToShow: 2.1,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 370,
                        settings: {
                            infinite: false,
                            slidesToShow: 1.6,
                            slidesToScroll: 1,
                        },
                    },
                ],
            })
            .on('setPosition', function(event, slick) {
                bLazy.revalidate();

                slick.$slides
                    .find('.slider__products__list__col')
                    .css('height', 'auto');
                slick.$slides
                    .find('.slider__products__list__col')
                    .css('height', slick.$slideTrack.height() + 'px');
                $(this)
                    .find('.slider__products__content')
                    .css('height', slick.$slideTrack.height() - 45 + 'px');
            });
    });

    $('.js-type-articles-slider').each(function () {
        $(this)
            .slick({
                dots: false,
                arrows: true,
                infinite: false,
                adaptiveHeight: false,
                speed: 300,
                slidesToShow: 2.7,
                slidesToScroll: 1,
                prevArrow: $(this)
                    .siblings('.type-articles__nav')
                    .find('.is-prev'),
                nextArrow: $(this)
                    .siblings('.type-articles__nav')
                    .find('.is-next'),
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            infinite: false,
                            slidesToShow: 1.5,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
    });
    /* End - Slider products */

    generate_offset();
    check_mobile_nav();

    createStars($('.js-rating-stars'), {
        starSize: 20,
        useFullStars: true,
        initialRating: 5,
        callback: function(currentRating, $el){
            $('.js-rating-form').find('input[name="rating"]').val(currentRating);
        }
    });

    $('.js-rating-form').validate({
        submitHandler: function(form) {
            Form.ajaxPost(form, function(data) {
                $('.js-rating-error').slideUp();

                if (!data.status) {
                    $('.js-rating-error').text(data.message).slideDown();
                } else {
                    $('.js-rating-form').fadeOut(250, function(){
                        $('.js-rating-success').fadeIn(250);
                    });
                }
            }, 'json');
        }
    });

    //fancybox
    $('[data-fancybox]').fancybox({
        thumbs: {
            autoStart: true,
        },
        video: {
            tpl: `
                <video class="fancybox-video" loop>
                    <source src="{{src}}" type="{{format}}" />
                </video>
            `,
            autoStart: true
        },
    });
});

function extrasort(a, b) {
    return b - a;
}

$(window).scroll(function() {
    if ($('.product__content__main__nav').is(':visible')) {
        if ($click_nav == 0) {
            check_nav();
        } else {
            setTimeout(function() {
                check_nav();
            }, 500);
        }
    }

    if (!$('.product__content__main__nav').is(':visible')) {
        check_mobile_nav();
    }
});

$(window).resize(function() {
    checkDescriptionHeight();

    if ($('.product__content__main__nav').is(':visible')) {
        check_nav();
    }
    if (!$('.product__content__main__nav').is(':visible')) {
        check_mobile_nav();
    }

    loadCustomVideo();
});

function generate_offset() {
    let offset_pos = new Array();

    $('.product__content__main__nav > li > a').each(function() {
        let box_id = $(this).attr('href');
        let box_offset = $(box_id).offset().top;

        offset_pos.push(box_offset);
    });

    offset_pos.sort(extrasort);

    setTimeout(function() {
        check_nav();
    }, 10);
}

function check_mobile_nav() {
    if ($('.product__content__main').length) {
        if ($(window).scrollTop() > $('.product__content__main').offset().top) {
            $('.product__content__main__mobile').addClass('show');
        } else {
            $('.product__content__main__mobile').removeClass('show');
        }
        if (
            $(window).scrollTop() >
            $('.product__content__main').offset().top +
                $('.product__content__main').outerHeight() -
                60
        ) {
            $('.product__content__main__mobile').addClass('hide-nav');
            $('.product__content__main__mobile__add').addClass('hide-btn');
        } else {
            $('.product__content__main__mobile').removeClass('hide-nav');
            $('.product__content__main__mobile__add').removeClass('hide-btn');
        }
    }

    check_nav();
}

function check_nav() {
    if ($('.product__content__main__nav').is(':visible')) {
        // auto detect navigation
        let actual_pos = $(window).scrollTop() + 20;
        let nav_a_count = offset_pos.length;

        for (let i = 0; i < nav_a_count; i++) {
            if (actual_pos >= offset_pos[i]) {
                $('.product__content__main__nav > li')
                    .eq(nav_a_count - 1 - i)
                    .addClass('active')
                    .siblings()
                    .removeClass('active');

                break;
            }
        }

        if (checkResolution('md;lg')) {
            $('.js-product-content-sidebar').css('width', $('.js-product-content-sidebar').width());

            if ($('.js-product-content-main').outerHeight() <= $('.js-product-content-sidebar').outerHeight() + 20) {
                $('.js-product-content-sidebar')
                    .removeClass('fixed')
                    .removeClass('fixed--bottom');
            } else {
                $('.js-product-content-sidebar').toggleClass('fixed', actual_pos - 20 >= $('.product__content__main').offset().top);

                if (
                    actual_pos - 20 >=
                    $('.product__content__main').offset().top +
                        $('.product__content__main').height() -
                        $('.js-product-content-sidebar').outerHeight()
                ) {
                    if ($('.js-product-content-sidebar').hasClass('fixed')) {
                        $('.js-product-content-sidebar').addClass('fixed--bottom');
                    }
                } else {
                    $('.js-product-content-sidebar').removeClass('fixed--bottom');
                }
            }
        }
    }

    if ($('.product__content__main__mobile').is(':visible')) {
        // auto detect navigation
        let actual_pos = $(window).scrollTop() + 20;
        let nav_a_count = offset_pos.length;

        for (let i = 0; i < nav_a_count; i++) {
            if (actual_pos >= offset_pos[i]) {
                $('.product__content__main__mobile__nav .dropdown-menu > li')
                    .eq(nav_a_count - 1 - i)
                    .addClass('active')
                    .siblings()
                    .removeClass('active');

                if (
                    !$('.product__content__main__mobile').hasClass('hide-nav')
                ) {
                    $(
                        '.product__content__main__mobile__nav .filter-option'
                    ).text(
                        $(
                            '.product__content__main__mobile__nav .dropdown-menu > li'
                        )
                            .eq(nav_a_count - 1 - i)
                            .find('a')
                            .text()
                    );
                }

                break;
            }
        }
    }
}
